import { saveThresholdChangeActions } from "./action";

const initialState = {
  changeRMAData: null,
};

const saveThresholdReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveThresholdChangeActions.SAVE_THRESHOLD_CHANGE_SUCCESS:
      return {
        ...state,
        changeRMAData: action.payload,
      };
    case saveThresholdChangeActions.SAVE_THRESHOLD_CHANGE_ERROR:
      return {
        ...state,
        changeRMAData: [],
      };
    default:
      return state;
  }
};

export default saveThresholdReducer;
